/*
 * takes two numbers
 * returns the relative percentage of the second number when compared to the first
 */
function percentage(full, partial) {
  return Math.round((partial / full) * 100);
}

export default percentage;
